import React, { useState, useContext, useEffect } from "react";
import Icon1 from "../../../../images/service_home.png";
import Icon2 from "../../../../images/service_home1.png";
import Icon3 from "../../../../images/service_home2.png";
import {
  ServicesContainer,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
  MainDesc,
} from "./ServicElements";
import * as PA from "./ServicElements";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { withRouter } from "react-router-dom";
import { LanguageContext } from "../../../../utils/language/Language";
import Counter from "../Counter";

const Services = ({ userData, history }) => {

  const [selectedLanguage, setSelectedLanguage] = useState(window.localStorage.getItem("rcml-lang") || "en");
  const { dictionary } = useContext(LanguageContext);
  const [currentPos, setCurrentPos] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((currentPos) => {
      setCurrentPos({
        lat: currentPos.coords.latitude,
        lng: currentPos.coords.longitude,
      });
    });
  }, []);

  return (
    <>
    <ServicesContainer id="services">
      <PA.PropertyHeadWrap>
        {/* <PA.ServiceText>{dictionary.menzilString.OUR_SERVICES}</PA.ServiceText> */}
        {/* <PA.FocusDesc>
          {dictionary.menzilString.Our} <PA.MainDesc>{dictionary.menzilString.Main}</PA.MainDesc> {dictionary.menzilString.Services}
        </PA.FocusDesc> */}
        <PA.FocusDesc>
          {dictionary.menzilString.Our_Main_Services} 
        </PA.FocusDesc>
      </PA.PropertyHeadWrap>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>
            {dictionary.menzilString.Buy_a} <MainDesc>{dictionary.menzilString.Property}</MainDesc>
          </ServicesH2>
          <ServicesP>
            {dictionary.menzilString.Buy_Property_Desc}
          </ServicesP>
          {/* <PA.PropertyViewBtn>
            <PA.ViewBtn
              onClick={() => {
                history.push(`/search-property?lat=${currentPos.lat}&long=${currentPos.lng}&sale_type=1&property_type=A`);
              }}
            >
              {dictionary.menzilString.Find_A_Home}
            </PA.ViewBtn>
          </PA.PropertyViewBtn> */}
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>
            {dictionary.menzilString.Sell} <MainDesc>{dictionary.menzilString.Property}</MainDesc>
          </ServicesH2>
          <ServicesP>
            {dictionary.menzilString.Sell_Property_Desc}
          </ServicesP>
          {/* <PA.PropertyViewBtn>
            <PA.ViewBtn
              onClick={() => {
                history.push("/search-property");
              }}
            >
              {dictionary.menzilString.Find_A_Home}
            </PA.ViewBtn>
          </PA.PropertyViewBtn> */}
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>
            {dictionary.menzilString.Become} <MainDesc>{dictionary.menzilString.Agent}</MainDesc>
          </ServicesH2>
          <ServicesP>
            {dictionary.menzilString.Become_Agent_Desc}
          </ServicesP>
          {/* <PA.PropertyViewBtn>
            <PA.ViewBtn
              onClick={() => {
                history.push("/search-property");
              }}
            >
              {dictionary.menzilString.Find_A_Home}
            </PA.ViewBtn>PropertyViewBtn
          </PA.PropertyViewBtn> */}
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
    {/* <Counter/> */}
    </>
  );
};

// export default Services;
const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Services));
